<template>
  <div class="home" v-wechat-title="$route.meta.title" style="height: 100%;">
    <Header/>
    <!-- <div class="ewm_activity activity_box wow slideInLeft animated" data-wow-duration="2s" data-wow-iteration="100">
      <div class="close_ewm_activity">ⓧ</div>
      <el-carousel :interval="2000" indicator-position="none" arrow="never">
        <a v-for="articleAd in articleAdData" :key="articleAd.id" :href=articleAd.targetUrl>
          <el-carousel-item>
            <el-image :src="articleAd.imgUrl"></el-image>
          </el-carousel-item>
        </a>
      </el-carousel>
    </div> -->
    <div class="ewm_activity activity_box wow slideInLeft animated">
      <div class="close_ewm_activity">ⓧ</div>
      <el-carousel :interval="4000" indicator-position="none" arrow="never">
        <a v-for="articleAd in articleAdData" :key="articleAd.id" :href=articleAd.targetUrl>
          <el-carousel-item>
            <el-image :src="articleAd.imgUrl"></el-image>
          </el-carousel-item>
        </a>
      </el-carousel>
    </div>
    <div id="bootstrap-touch-slider" class="carousel bs-slider slide control-round indicators-line" data-ride="carousel" data-pause="hover" data-interval="5000">
      <ol class="carousel-indicators">
        <li data-target="#bootstrap-touch-slider" v-for="(item, index) in bannerData" :key="index" :data-slide-to="index" :class="[ index == 0 ? 'active' : '']"></li>
      </ol>
      <div class="carousel-inner" role="listbox">
        <div v-for="(item, index) in bannerData" :key="item.id" v-bind:style="{backgroundImage:'url('+item.pic+')'}"  class="item" :class="[index == 0 ? 'active' : '']">
            <div class="bs-slider-overlay"></div>
            <div class="container">
                <div class="row">
                    <div class="slide-text slide_style_center">
                        <h1 data-animation="animated FadeIn">{{ bannerMsg[index].title }}</h1>
                        <p @click="contentToColumn(bannerMsg[index].columnInfo1)" data-animation="animated lightSpeedIn">{{ bannerMsg[index].button1 }}</p>
                        <p @click="contentToColumn(bannerMsg[index].columnInfo2)" data-animation="animated fadeInLeft">{{ bannerMsg[index].button2 }}</p>
                        <p @click="contentToColumn(bannerMsg[index].columnInfo3)" data-animation="animated lightSpeedIn">{{ bannerMsg[index].button3 }}</p>
                        <p @click="contentToColumn(bannerMsg[index].columnInfo4)" data-animation="animated fadeInLeft">{{ bannerMsg[index].button4 }}</p>
                        <!-- <a data-animation="animated fadeInLeft" :class="{bannerButton_statue: bannerMsg[index].button1 == ''}" class="btn btn-default">
                          {{ bannerMsg[index].button1 }}
                        </a> -->
                    </div>
                </div>
            </div>
        </div>
      </div>
      <a class="left carousel-control" href="#bootstrap-touch-slider" role="button" data-slide="prev">
          <span class="fa fa-angle-left" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
      </a>
      <a class="right carousel-control" href="#bootstrap-touch-slider" role="button" data-slide="next">
          <span class="fa fa-angle-right" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
      </a>
    </div>
    <div class="home_main_box" id="home_main_box"> 
      <div class="site_width"> 
        <div class="width8 wow FadeInL animated" data-wow-delay=".3s"> 
          <div class="padding15"> 
            <div class="home_section_title">
                破产资讯 
              <div class="go_more">
                <a @click="contentMoreNews()" title="更多资讯"><i class="fa fa-bars"></i></a>
              </div> 
            </div> 
          </div> 
          <div class="owl_carousel_cbb owl-carousel owl-theme owl-theme_home owl-loaded"> 
            <div class="owl-stage-outer">
              <div class="owl-stage"> 
                <div class="owl-item" v-for="item in newsData" :key="item.id">
                  <div class="padding15">
                    <a @click="contentTo(item.id)" class="news_link_data">
                      <div class="news_pic">
                        <img v-if="item.pic" :src=item.pic>
                        <img v-else :src=defaultImg>
                        <div class="time">
                          <h3>{{ formatDateDay(item.created) }}</h3>
                          <span>{{ formatDate(item.created) }}</span>
                        </div>
                      </div>
                      <div class="news_detail">
                        <div class="padding15">
                          <h3>{{ item.title }}</h3>
                          <p>{{ item.summary }}</p>
                          <em>阅读详情</em>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div> 
            </div> 
          </div> 
        </div>
        <div class="width4 wow FadeInR animated" data-wow-delay=".3s"> 
          <div class="padding15"> 
            <div class="home_section_title">
              学术论文 
            </div> 
          </div> 
          <div class="owl_carousel_cbw owl-carousel owl-theme owl-theme_home owl-loaded"> 
            <div class="owl-stage-outer">
              <div class="owl-stage">
                <div class="owl-item" v-for="item in learningData" :key="item.id">
                  <div class="padding15"> 
                    <a @click="contentTo(item.id)" class="news_link_data"> 
                      <div class="home_cbw_box"> 
                        <div>
                          <i class="fa fa-quote-left"></i>
                        </div> 
                        <h3>{{ item.title }}</h3> 
                        <p> {{ item.summary }} </p> 
                        <div style="text-align: right;">
                          <i class="fa fa-quote-right"></i>
                        </div> 
                      </div> 
                    </a> 
                    <div v-if="item.lawyersInfo" class="home_team_pic"> 
                      <img :src=item.lawyersInfo[0].pic style="width: 70px; height: 70px;"> 
                      <p>{{ item.lawyersInfo[0].userName }}<span>{{ item.lawyersInfo[0].qualification }}</span></p> 
                      <div class="view_team"> 
                        <a  @click="contentToLawyer(item.lawyersInfo[0].id)">查看简历</a> 
                      </div> 
                    </div> 
                    <div v-else class="home_team_pic"> 
                    </div> 
                  </div>
                </div>
              </div>
            </div>
          </div> 
        </div> 
        <div class="clear"></div> 
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
  import '@/assets/js/bootstrap.min.js'
  import '@/assets/js/jquery.touchSwipe.min.js'
  import '@/assets/js/bootstrap-touch-slider.js'
  import '@/assets/js/legaltech.js'

  export default {
    name: "home",
    data() {
      return {
        bannerMsg:[{
          title: '',
          msg:'',
          button1: '',
          button2: '',
          button3: '',
          button4: '',
          columnInfo1: {},
          columnInfo2: {},
          columnInfo3: {},
          columnInfo4: {}
        },{
          title: '一家做破产业务的律师事务所',
          msg:'',
          button1: '了解更多',
          button2: '',
          button3: '',
          button4: '',
          columnInfo1: {
            routerName: 'about',
            id: 1,
            name: '关于金展',
            parentId: 0
          },
          columnInfo2: {},
          columnInfo3: {},
          columnInfo4: {}
        },{
          title: '在这里读懂破产法',
          msg:'',
          button1: '关注破产资讯',
          button2: '寻找破产法规案例',
          button3: '了解破产理论',
          button4: '查询破产公告',
          columnInfo1: {
            routerName: 'bankruptcyNews',
            id: 3,
            name: '破产资讯',
            parentId: 0
          },
          columnInfo2: {
            routerName: 'lawsCases',
            id: 4,
            name: '法规案例',
            parentId: 0
          },
          columnInfo3: {
            routerName: 'bankruptcyResearch',
            id: 5,
            name: '破产研究',
            parentId: 0
          },
          columnInfo4: {
            routerName: 'bankruptcyAnnouncement',
            id: 6,
            name: '破产公告',
            parentId: 0
          }
        },{
          title: '专业为您解决破产法律问题',
          msg:'',
          button1: '',
          button2: '',
          button3: '',
          button4: '',
          columnInfo1: {},
          columnInfo2: {},
          columnInfo3: {},
          columnInfo4: {}
        }],
        defaultImg: require('@/assets/images/news_default.jpg'),
        bannerData: [],
        newsData: [],
        articleAdData: [],
        learningData: [],
        bannerPageParams: {
          state: 0,
          pageNo: 1,
          pageSize: 4
        },
        newsPageParams: {
          columnId: 3,
          state: 0,
          pageNo: 1,
          pageSize: 6
        },
        newsParentId: 0,
        newsColumnName: '破产资讯',
        lawyerPageParams: {
          columnId: 25,
          state: 0,
          pageNo: 1,
          pageSize: 5
        },
        lawyerColumnName: '学术论文',
        lawyerParentId: 5,
        qcOptions: [
          {id: 0, label: '高级合伙人'},
          {id: 1, label: '合伙人'},
          {id: 2, label: '顾问'},
          {id: 3, label: '资深律师'},
          {id: 4, label: '律师'},
          {id: 5, label: '律师助理'}
        ],
        isFirstShow: true
      }
    },
    mounted() {
      this.getBannerList()
      this.getArticleAd()
      this.getNewsPageList()
      this.getLawyerPageList()
      document.getElementsByTagName('body')[0].style.height = '100%'
      document.getElementsByTagName('html')[0].style.height = '100%'
      // 监听动画
      this.$nextTick(() => { // 在dom渲染完后,再执行动画
        $('#bootstrap-touch-slider').bsTouchSlider()
        const _this = this
        $('#bootstrap-touch-slider').on('slide.bs.carousel', function () {
    　　　 const carouselData = $(this).data('bs.carousel')
    　　　 const items = carouselData.$items // 所有图片的包裹div的数组
          if (items != null && items.length > 3) {
            if (items[2].className == 'item active' && _this.isFirstShow && _this.$route.name == 'home') {
              setTimeout(function() {
                $(".black_bg").show()
                $(".activity_box").show()
                _this.isFirstShow = false
              }, 1000)
            }
          }
        })
      })
    },
    methods: {
      getBannerList() {
        this.isLoading = true
        this.$axios.get(this.$apiUrl.INDEXPIC_PAGE_API_URL, 'Json', this.bannerPageParams)
        .then(res => {
          this.isLoading = false
          if (res.data.code == 200) {
            this.bannerData = res.data.data.list
          } else {
            rescode(this, res)
          }
        }).catch(err => {
            this.isLoading = false
            this.$message.error("服务器出现差错")
        })
      },
      getNewsPageList() {
        this.isLoading = true
        this.$axios.get(this.$apiUrl.NEWS_PAGE_API_URL, 'Json', this.newsPageParams)
        .then(res => {
          this.isLoading = false
          if (res.data.code == 200) {
            this.newsData = res.data.data.list
            this.owlCarouselCbb()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
            this.isLoading = false
            this.$message.error("服务器出现差错")
        })
      },
      getLawyerPageList() {
        this.isLoading = true
        this.$axios.get(this.$apiUrl.NEWS_PAGE_API_URL, 'Json', this.lawyerPageParams)
        .then(res => {
          this.isLoading = false
          if (res.data.code == 200) {
            this.learningData = res.data.data.list
            this.owlCarouselCwb()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
            this.isLoading = false
            this.$message.error("服务器出现差错")
        })
      },
      getArticleAd() {
        this.isLoading = true
        this.$axios.get(this.$apiUrl.ARTICLE_AD_PAGE_API_URL, 'Json', {
          state: 0,
          pageNo: 1,
          pageSize: 8
        })
        .then(res => {
          this.isLoading = false
          if (res.data.code == 200) {
            this.articleAdData = res.data.data.list
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
            this.isLoading = false
            this.$message.error("服务器出现差错")
        })
      },
      contentTo(id) {
        this.$router.push({
          name: "columnContent",
          params: {
            id: id,
            columnId: this.newsPageParams.columnId,
            columnName: this.newsColumnName,
            parentId: this.newsParentId
          }
        })
      },
      contentToColumn(columnInfo) {
        if (columnInfo == {}) return
        this.$router.push({
          name: columnInfo.routerName
        })
      },
      contentMoreNews() {
        this.$router.push({
          name: 'bankruptcyNews'
        })
      },
      contentToLawyer(id) {
        this.$router.push({
          name: "lawyerDetail",
          params: {
            id: id,
            columnId: this.lawyerPageParams.columnId,
            columnName: this.lawyerColumnName,
            parentId: this.lawyerParentId
          }
        })
      },
      formatDate(date) {
        if(date == undefined){
          return ''
        }
        return this.$moment(date).format("YYYY年MM月")
      },
      formatDateDay(date) {
        if(date == undefined){
          return ''
        }
        return this.$moment(date).date()
      },
      owlCarouselCbb() {
        setTimeout(function() {
          $(".owl_carousel_cbb").owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            dots: false,
            autoplay: true,
            autoplayTimeout: 5000,
            responsive: {
              0: {
                  items: 1
              },
              415: {
                  items: 2
              }
            }
          })
        }, 100)
      },
      owlCarouselCwb() {
        setTimeout(function() {
          $(".owl_carousel_cbw").owlCarousel({
            items: 1,
            loop: true,
            margin: 10,
            nav: true,
            dots: false,
            autoplay: true,
            autoplayTimeout: 5000
          })
        }, 100)
      }
    },
    watch:{
      $route(to,from){
        this.isFirstShow = true
      }
    }
  }
</script>
<style scoped>
  .bannerButton_statue {
    display: none;
  }
</style>